import React, { useState } from 'react'

import useFirebase from 'hooks/firebase'

import { useUtils } from 'config/utils'

import {
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
} from '@mui/material'

import PersonAddIcon from '@mui/icons-material/PersonAdd'

import LoadingButton from '@mui/lab/LoadingButton'

const CreateDirector = (props) => {
  const { schoolId } = props
  const { validateEmail } = useUtils()
  const { functions } = useFirebase()
  const { createUser } = functions

  const [loading, setLoading] = useState(false)

  const [firstName, setFirstName] = useState('')
  const handleFirstNameChanged = (event) => {
    setFirstName(event.target.value)
  }

  const [fathersLastName, setFathersLastName] = useState('')
  const handleFathersLastNameChanged = (event) => {
    setFathersLastName(event.target.value)
  }

  const [mothersLastName, setMothersLastName] = useState('')
  const handleMothersLastNameChanged = (event) => {
    setMothersLastName(event.target.value)
  }

  const [email, setEmail] = useState('')
  const handleEmailChanged = (event) => {
    setEmail(event.target.value)
  }

  const onCreate = async () => {
    setLoading(true)
    const data = {
      'role': 'director',
      'schoolId': schoolId,
      'user': {
        'firstName': firstName,
        'fathersLastName': fathersLastName,
        'mothersLastName': mothersLastName,
        'name': `${firstName} ${fathersLastName}`,
        'email': email,
      },
    }
    await createUser(data)
    setLoading(false)
    clean()
  }

  const clean = () => {
    setFirstName('')
    setFathersLastName('')
    setMothersLastName('')
    setEmail('')
  }

  return (
    <Card sx={{ borderColor: '#655dc633', borderRadius: 2, p: 2 }}>
      <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography color='primary' variant='body1'>
              <b style={{ fontWeight: 900 }}>CREAR DIRECTOR</b>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              disabled={loading}
              value={firstName}
              onChange={handleFirstNameChanged}
              placeholder='Ingresa el nombre'
              label='Nombre'
              InputLabelProps={{ shrink: true }}
              fullWidth
              sx={{ flexGrow: 1 }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              disabled={loading}
              value={fathersLastName}
              onChange={handleFathersLastNameChanged}
              placeholder='Ingresa el apellido paterno'
              label='Apellido paterno'
              InputLabelProps={{ shrink: true }}
              fullWidth
              sx={{ flexGrow: 1 }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              disabled={loading}
              value={mothersLastName}
              onChange={handleMothersLastNameChanged}
              placeholder='Ingresa el apellido materno'
              label='Apellido materno'
              InputLabelProps={{ shrink: true }}
              fullWidth
              sx={{ flexGrow: 1 }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              disabled={loading}
              value={email}
              onChange={handleEmailChanged}
              placeholder='Ingresa el email'
              label='Email'
              InputLabelProps={{ shrink: true }}
              fullWidth
              sx={{ flexGrow: 1 }}
            />
          </Grid>
          <Grid item xs={12} align='right'>
            <LoadingButton disabled={firstName === '' || fathersLastName === '' || mothersLastName === '' || !validateEmail(email)} disableElevation loading={loading} loadingPosition='start' startIcon={<PersonAddIcon />} variant='contained' onClick={onCreate}>
              <b style={{ fontWeight: 900 }}>{ loading ? 'CREANDO' : 'CREAR' }</b>
            </LoadingButton>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default CreateDirector